export default "__VITE_ASSET__Dv2jStQ3__"